module.exports = __webpack_public_path__ + "img/my-type-5.65fe329b.png";